export const NipCheck = (json: INipCheck): INipCheckModel => {
	const fromJSON = (json: INipCheck) => {
		const { full_street, postal_code, ...rest } = json
		return {
			fullStreet: full_street,
			postalCode: postal_code,
			...rest,
		}
	}
	return { ...fromJSON(json) }
}

export const nipToJSON = (obj: Partial<INipCheckModel>): Partial<INipCheck> => {
	const { fullStreet, postalCode, ...rest } = obj
	return {
		full_street: fullStreet,
		postal_code: postalCode,
		...rest,
	}
}
